PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX ccf: <http://purl.org/ccf/>

SELECT *
#{{FROM}}
WHERE {
  [] ccf:has_registration_location ?rui_location .
  ?rui_location
    rdf:type ccf:SpatialEntity ;
    ccf:x_dimension ?x ;
    ccf:y_dimension ?y ;
    ccf:z_dimension ?z ;
    ccf:dimension_unit ?units .
}
